
import { mapMutations } from 'vuex'
import Blog from '~/components/Common/Blog'
import Content from '~/components/Common/Blog/BlogContent/HtmlFileType'

export default {
    name: 'BlogHtmlFile',
    components: { Blog, Content },
    props: {
        newsType: String,
        menuType: {
            type: String,
            default: null,
        },
        pageTitle: String,
        date: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            colKey: ['title', 'sendDate'],
        }
    },
    created() {
        this.SET_COL(this.colKey)
    },
    methods: {
        ...mapMutations('board', ['SET_COL']),
    },
}
